export default (command: string) => {
  // "COMMAND#TIMESTAMP"
  if (COMMANDS.includes(command as any)) {
    return `${command}#${Date.now()}`
  } else {
    throw new Error(`Could not generate Job Id for ${command}`)
  }
}
export const getCommand = (jobId: string) => {
  const command = jobId.split('#')[0]
  return COMMANDS.includes(command as any) ? command : null
}
const COMMANDS = [
  // Flight Control Commands
  'TAKEOFF',
  'LAND',
  'GOTOLOCATION',
  'GOTOSAFELOCATION',
  'GOTODOCKINGSTATION',
  'GOTO-ALTERNATE-SAFE-LOCATION',
  'STOPGOTOSAFELOCATION',
  'STOPGOTODOCKINGSTATION',

  // Mission Control Commands
  'START',
  'STOP',
  'PAUSE',
  'RESUME',
  'EMERGENCY_STOP',
  'UPLOAD',
  'UPLOAD_RC',
  'EXPORT_KMZ',
  'RUN_MISSION',
  'SYNC_FENCE',

  // Pre/Post Flight Commands
  'PRE_TAKEOFF',
  'PRE_LAND',

  // Stream Commands
  'START_STREAM_RC',
  'START_STREAM_DOCK',
  'STOP_STREAM_RC',
  'STOP_STREAM_DOCK',
  'START_STREAM_SLINKTECH',
  'STOP_STREAM_SLINKTECH',
  // Precision Landing Commands
  'START_PL',
  'STOP_PL',

  // Drone Control Commands
  'ENGAGE_DRONE',
  'DISENGAGE_DRONE',

  // Virtual Stick Commands
  'ENABLE_VIRTUALSTICK',
  'DISABLE_VIRTUALSTICK',
  'VIRTUAL_STICK_ADVANCED_MODE_ENABLED',
  'VIRTUAL_STICK_ADVANCED_MODE_DISABLED',

  // Camera and Sensor Commands
  'AUTO_FOCUS',
  'THERMAL_CONTROL',

  // Camera Mission Commands
  'CAMERA_ZOOM',
  'CAMERA_ISO',
  'CAMERA_SHUTTER_SPEED',
  'CAMERA_PHOTO',
  'CAMERA_RECORD',
  'CAMERA_EXPOSURE_COMPENSATION',
  'CAMERA_EXPOSURE_MODE',
  'CAMERA_MODE',
  'CAMERA_VIDEO_SOURCE',
  'CAMERA_PHOTO_INTERVAL_SHOOT',

  // Gimbal Mission Commands
  'GIMBAL_RECENTER',
  'GIMBAL_YAW_FOLLOW',
  'GIMBAL_FREE',
  'DEBUG_MODE_ENABLE',
  'DEBUG_MODE_DISABLE',

  // Lighting Commands
  'LED_SETTINGS',
  'BOTTOM_AUX_LIGHTS',
  'TOP_AUX_LIGHTS',

  // Safety and Obstacle Avoidance
  'DISABLE_OBSTACLE_AVOIDANCE',
  'ENABLE_OBSTACLE_AVOIDANCE',

  // Simulator Commands
  'START_SIMULATOR',
  'STOP_SIMULATOR',

  // Device Configuration Commands
  'SEND_DEVICE_CONFIG',
  'BIND_START',
  'BIND_STOP',

  // MAVLink Aircraft Commands (FLY3D-965)
  'SET_MODE',
  'DO_ACTION',
  'SET_WP',
  'SET_MOUNT',
  'DO_ORBIT',

  // Job Management Commands
  'CANCEL_JOB',
  'GET_ALL_JOBS',

  // Takeoff Pitch Commands
  'TAKEOFFPITCH_PLUS',
  'TAKEOFFPITCH_MINUS',
  'TAKEOFFPITCH_VALUE',

  // Charging Commands
  'DRONE_CHARGE_START',
  'DRONE_CHARGE_STOP',
  'RC_CHARGE_START',
  'RC_CHARGE_STOP',

  // Automation Commands
  'START_MISSION_AUTOMATION',
  'START_MISSION',

  'CONFIG_UPDATE',

  // Dock Charging Commands
  'DOCK_BATTERY_CHARGE_START',
  'DOCK_BATTERY_CHARGE_STOP',

  // Dock Power Commands
  'DRONE_POWER_ON',
  'DRONE_POWER_OFF',
  'RC_POWER_ON',
  'RC_POWER_OFF',
  'DRONE_RC_POWER_ON',
  'DRONE_RC_POWER_OFF',

  // Dock Enclosure Commands
  'ENCLOSURE_OPEN',
  'ENCLOSURE_CLOSE',
  'ENCLOSURE_MOVE_TO_POSITION',
  'ENGAGE_DRONE',
  'DISENGAGE_DRONE',

  // Dock Lighting Commands
  'INTERNAL_LIGHTS_ON',
  'INTERNAL_LIGHTS_OFF',
  'EXTERNAL_LIGHTS_ON',
  'EXTERNAL_LIGHTS_OFF',
  'BLINK_LIGHTS',

  // Dock Cooling Commands
  'FAN_GROUP_1_ON',
  'FAN_GROUP_1_OFF',
  'FAN_GROUP_2_ON',
  'FAN_GROUP_2_OFF',

  // Dock Servo Commands
  'RC_SERVO_ANGLE_1',
  'RC_SERVO_ANGLE_2',
  'DRONE_SERVO_ANGLE_1',
  'DRONE_SERVO_ANGLE_2',
  'DRONE_SERVO_ANGLE_3',

  // Dock HVAC Commands
  'HEATER_ON',
  'HEATER_OFF',
  'HVAC_AUTO',

  // Dock System Commands
  'SYSTEM_STATUS',
  'SYSTEM_RESET',
  'SYSTEM_REBOOT',

  // Media Commands
  'FORMAT_SD',
  'DOWNLOAD_ALL_MEDIA',

  // Dock Routine Commands
  'POST_TAKEOFF_SUCCESSFUL',
  'POST_TAKEOFF_FAILED',
  'POST_LAND_SUCCESSFUL',
] as const

export type COMMANDS = (typeof COMMANDS)[number]
